// @ts-nocheck
import React, { useState, useCallback } from "react";
import { useAuth } from "react-oidc-context";
import config from "constants/config";
import isEmail from "validator/lib/isEmail";
import { Container, Row, Col, Form, Button, Spinner, ListGroup, Stack } from "react-bootstrap";
import "./i18n";
import "./styles/bootstrap.overides.scss";
const EmailEnter = () => {
  const auth = useAuth();
  const externalLinkRegion = config.defaultCountyCode === "US" ? "us" : "anz";
  const [enteredEmail, setEnteredEmail] = useState<any>("");
  const [invalidEmail, setInvalidEmail] = useState<any>(false);
  const [isLoading, setIsLoading] = useState<any>(false);

  const getHostUrl = useCallback(
    () => `${config.scheme}://${config.host === "admin_ui_1" ? `${config.host}:${config.port}` : config.host}`,
    [config.scheme, config.host, config.port]
  );

  const getIdp = useCallback(async (email) => {
    const url = config.ADMIN.apiHost + "/api/emailcheck";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(email),
      });
      return await response.text();
    } catch (e) {
      console.error("IDP check failed:", e);
      return null;
    }
  }, []);

  const submit = useCallback(async () => {
    if (!enteredEmail || !isEmail(enteredEmail)) {
      setInvalidEmail(true);
      return;
    }
    setIsLoading(true);
    setInvalidEmail(false);
    try {
      const idpProvider = await getIdp(enteredEmail);
      const loginOptions = {
        extraQueryParams: idpProvider
          ? { kc_idp_hint: idpProvider, login_hint: enteredEmail }
          : { login_hint: enteredEmail },
      };
      await auth.signinRedirect(loginOptions);
    } catch (e) {
      console.error("Authentication error:", e);
      setIsLoading(false);
    }
  }, [enteredEmail, getIdp, auth]);

  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  return (
    <div className="email-enter-wrapper d-flex flex-column min-vh-100">
      <header className="py-3 bg-white" style={{ borderBottom: "1px solid #ff0000" }}>
        <Container>
          <Row className="justify-content-center">
            <Col xs="auto" className="text-center">
              <a href={getHostUrl()} className="d-inline-flex align-items-center text-decoration-none">
                <span className="logo" />
              </a>
            </Col>
          </Row>
        </Container>
      </header>

      <Container className="flex-grow-1 d-flex flex-column justify-content-start py-4">
        <Row className="justify-content-center">
          <Col xs={12} md={5} lg={4}>
            <h1 className="mb-4">QJumpers Sourcing and Recruitment Software Login</h1>
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  value={enteredEmail}
                  //placeholder="name@company.com"
                  disabled={isLoading}
                  isInvalid={invalidEmail}
                  onChange={(e) => {
                    const v = e.target.value;
                    setEnteredEmail(v);
                    if (invalidEmail && isEmail(v)) {
                      setInvalidEmail(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      submit();
                    }
                  }}
                  autoComplete="off"
                  autoFocus
                />
                <Form.Control.Feedback type="invalid">Invalid email.</Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-4">
                <Button variant="success" size="lg" type="submit" disabled={isLoading}>
                  {isLoading && <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />}
                  {isLoading ? "Signing in..." : "Next"}
                </Button>
              </div>
            </Form>

            <div className="mt-5">
              <p className="mb-2">
                If you are an employer and your organisation doesnt already have an account with QJumpers, please email{" "}
                <strong>support@qjumpers.com</strong> for a registration link.
              </p>
              <p className="mb-4">
                If your organisation already has a QJumpers account please contact your HR Team for access.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <footer className="mt-auto py-3 bg-white" style={{ borderTop: "1px solid #ff0000" }}>
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} md={5} lg={4}>
              <Row>
                <Col className="text-start">
                  <Stack direction="horizontal" gap={0} className="flex-wrap small kc-container-wrapper">
                    <a href="mailto:support@qjumpers.com">support@qjumpers.com</a>
                    <span>NZ 07 927 2777 / 0800 758 673</span>
                    <span>US 469-606-0992</span>
                    <a
                      id="terms-conditions"
                      className="text-decoration-none"
                      href={`https://qjumpers.com/${externalLinkRegion}/terms-conditions/`}
                      target="_blank"
                      rel="noreferrer">
                      Terms &amp; Conditions
                    </a>
                    <a
                      id="ai-talent-sourcing-terms-conditions"
                      className="text-decoration-none"
                      href="/AISourcingterms"
                      target="_blank"
                      rel="noreferrer">
                      AI Talent Sourcing Terms &amp; Condition
                    </a>
                    <a
                      id="privacy-statement"
                      className="text-decoration-none"
                      href={`https://qjumpers.com/${externalLinkRegion}/privacy-policy/`}
                      target="_blank"
                      rel="noreferrer">
                      Privacy Statement
                    </a>
                  </Stack>
                </Col>
                <Col className="text-end">
                  <span className="logo" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default EmailEnter;
